<template>
  <div :class="$style.style">
    <div class="ad">
      <img :src="activityBackgroundImage" alt="">
      <img class="bgimg" src="//img1.jianyewy.com/ca8e5c5cb798586d19417c4e3108983d.png" alt="">
    </div>
    <div class="titleDiv">
      <!-- <p>亲子活动报名</p> -->
      <p style="white-space: pre-wrap">{{activityTitle?activityTitle:'报名活动名称'}}</p>
      <div>
        <ul class="content">
          <li>
            <div class="left">
              报名时间：
            </div>
            <div class="right">
              <!-- {{signStartTime | dateFormat('yyyy-MM-dd hh:mm:ss') }}至{{signEndTime | dateFormat('yyyy-MM-dd hh:mm:ss') }} -->
              {{signStartTime!==""?signStartTime:(new Date()).valueOf() | dateFormat('yyyy-MM-dd hh:mm:ss') }} 至{{signEndTime!==""?signEndTime:(new Date()).valueOf() | dateFormat('yyyy-MM-dd hh:mm:ss') }}
            </div>
          </li>
          <li>
            <div class="left">
              限报人数：
            </div>
            <div class="right">
              {{activityLimitCount | numberFilter}}人
            </div>
          </li>
        </ul>
       
      </div>
    </div>
    <div class="contentDiv">
      <p>活动内容</p>
      <ul>
        <li>
          <p class="title">活动地点</p>
          <p class="content" style="white-space: pre-wrap">{{activityAddress}}</p>
        </li>
        <li>
          <p class="title">活动时间</p>
          <p class="content">
            <!-- {{activityStartTime | dateFormat('yyyy-MM-dd hh:mm:ss') }}至{{activityEndTime | dateFormat('yyyy-MM-dd hh:mm:ss') }} -->

             {{activityStartTime!==""?activityStartTime:(new Date()).valueOf() | dateFormat('yyyy-MM-dd hh:mm:ss') }} 至{{activityEndTime!==""?activityEndTime:(new Date()).valueOf() | dateFormat('yyyy-MM-dd hh:mm:ss') }}


          </p>
        </li>
        <li>
          <p class="title">活动内容</p>
          <p class="content" v-html="activityContent" id="fuwenben">

            </p>
          <!-- <p class="branch">活动规则：每人最多可报( {{activityPerLimitCount}} )个名额</p>--> 
        </li>
        
      </ul>
    </div>
   
    <div class="btn-sign">我要报名</div>
  </div>
</template>
<script>
import Filter from '../utils/filter';
export default {
  data() {
    return {};
  },
  filters: {
    dateFormat: function(date, fmt) {
      return Filter.date(date || '', fmt);
    },
    numberFilter: function(value) {
      if (value == 99999) {
        return '不限制';
      } else {
        return value;
      }
    }
  },

  props: {
    activityTitle: String,
    signStartTime: String,
    signEndTime: String,
    activityBackgroundImage: String,
    activityStartTime: String, //活动开始时间 时间戳
    activityEndTime: String, //活动结束时间
    activityAddress: String, //活动地点
    activityLimitCount: String, //活动限制报名人数
    activityPerLimitCount: String, //每人限制报名人数
    activityContent: String
  }
};
</script>
<style lang="less" module>
:local(.style) {
  position: relative;
  padding-bottom: 50px;
  box-sizing: border-box;
  // background-color: red;
  * {
    font-size: 12px;
    margin: 0;
    padding: 0;
  }
  #fuwenben {
    white-space: pre-wrap;
    img {
      width: 100%;
    }
  }
  .ad {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    img.bgimg {
      position: absolute;
      width: 100%;
      display: block;
      left: 0;
      bottom: -16px;
    }
    height: 120px;
    position: relative;
    // border-radius: 0 0 50% 50%;
  }
  .ad:after,
  .img:after {
    width: 140%;
    height: 120px;
    position: absolute;
    left: -20%;
    top: 0;
    z-index: -1;
    content: '';
    border-radius: 0 0 50% 50%;
    background-color: #fff;
  }
  .titleDiv {
    padding: 20px;
    position: relative;
    z-index: 1;
    margin-top: -30px;
    > p {
      font-size: 16px;
      font-weight: bolder;
      margin: 16px 0;
      color: #333;
    }

    .content:after {
      content: '.';
      display: block;
      height: 0;
      visibility: hidden;
      clear: left;
    }
    .content {
      border: 1px #c7c4c4 solid;
      padding: 12px 8px;
      color: #666;
      li {
        line-height: 20px;
        .left {
          float: left;
          width: 60px;
        }
      }
    }
  }

  .contentDiv {
    background: #f6f6f7;
    margin: 0 20px;
    padding: 1px 0 20px 0;

    .title {
      margin: 0;
    }
    > p {
      font-size: 16px;
      text-align: center;
      margin: 20px 0;
      font-weight: bold;
      position: relative;
      color: #333;
    }
    > p:before {
      content: '';
      width: 30px;
      height: 2px;
      background: #909090;
      position: absolute;
      left: 30px;
      top: 10px;
    }
    > p:after {
      content: '';
      width: 30px;
      height: 2px;
      background: #909090;
      position: absolute;
      right: 30px;
      top: 10px;
    }
    p.content {
      word-wrap: break-word;
      color: #666;
    }
    ul {
      li {
        padding: 0 20px;
        .title {
          font-size: 13px;
          font-weight: bold;
          margin: 10px 0;
          color: #333;
          position: relative;
          z-index: 1;
        }
        p.title:after {
          content: '';
          position: absolute;
          width: 68px;
          background: #eae8e8;
          height: 10px;
          left: -8px;
          bottom: -2px;
          z-index: -1;
        }
        .branch {
          margin-top: 10px;
        }
      }
    }
  }
  .img {
    width: 210px;
    height: 100px;
    margin: auto;
    background-color: #909090;
  }
  .btn-sign {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    background-color: #fba32e;
    position: absolute;
    bottom: 0px;
  }
}
</style>

